import Transport, { limit, offset } from '../../common/services/api/Transport';

const transport = new Transport();

export const getMeetings = async (pageNumber = 1) => {
    try {
        const result = await transport.get({
            path: `meetings?limit=${limit}&offset=${offset(pageNumber)}`,
        });
        return result.data.statusCode === 200
            ? { ...result.data.data, count: Math.ceil(result.data.data.count / limit) }
            : {};
    } catch (error) {
        return null;
    }
};

export const getMeeting = async meetingId => {
    try {
        const result = await transport.get({ path: `meetings/${meetingId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const getMeetingsAcl = async meetingId => {
    try {
        const result = await transport.get({ path: `meetings/acl` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const getMeetingAcl = async meetingId => {
    try {
        const result = await transport.get({ path: `meetings/${meetingId}/acl` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const getMeetingTitleTemplates = async () => {
    try {
        const result = await transport.get({ path: `meetings/title-templates` });
        return result.data.statusCode === 200 ? result.data.data.meetingTitleTemplates : [];
    } catch (error) {
        return null;
    }
};

export const updateMeeting = async (meetingId, meetingData) => {
    try {
        const result = await transport.put({ path: `meetings/${meetingId}`, data: meetingData });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const publishSummaryForm = async meetingId => {
    try {
        const result = await transport.put({ path: `meetings/${meetingId}/publish-summary-form` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const revertSummaryForm = async meetingId => {
    try {
        const result = await transport.put({ path: `meetings/${meetingId}/revert-summary-form` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const approveSummaryForm = async meetingId => {
    try {
        const result = await transport.put({ path: `meetings/${meetingId}/approve-summary-form` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const createMeeting = async meetingData => {
    try {
        const result = await transport.post({ path: `meetings`, data: meetingData });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const deleteMeeting = async meetingId => {
    try {
        const result = await transport.delete({ path: `meetings/${meetingId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};
